/**
 * `/accounts/:accountId/assistants/:AssistantID/myassistant/subagents` — the only
 * place Subagents is mounted (`agent-subagents/router.tsx`, under the
 * `myassistant` group). Anchored at both ends, so anything nested below never
 * matches; a substring test would also catch an id that happens to contain the
 * segment.
 */
const SUBAGENTS_ROUTE = /^\/accounts\/[^/]+\/assistants\/[^/]+\/myassistant\/subagents\/?$/;

export function isSubagentsPath(pathname: string): boolean {
  return SUBAGENTS_ROUTE.test(pathname);
}
